
// Description:
// An adskin (aka takeover) is a combination of a top ad unit with a background wallpaper
// Usually found on certain category pages and logged in/out homepages

// Mechanics:
// Whether a page has an adskin or not is defined in DFP (DoubleClick for Publishers)
// A top ad loads with a js payload > the payload contains an onloaded callback > the callback calls our adskin function
// An example payload with a callback to our adskin func looks like this:
// https://gist.github.com/benpink/3ca5f9d36949469c0d42

class AdSkin {

    constructor (bgImg, clkPth, trkPth, bgColor) {
        this.render(bgImg, bgColor);
    };

    render (bgImg, bgColor) {
        let el = document.body;

        el.className += ' show-adskin box-well';
        el.style.backgroundImage = `url(${bgImg})`;

        if (bgColor) {
            el.style.backgroundColor = bgColor;
        }

        // This is required to move the skin position down when we render a subnav
        if (document.getElementById('gallery-nav')) {
            el.className += ' has-subnav';
        }
    };
};

export default AdSkin;



// WEBPACK FOOTER //
// ./assets/es6/common/adskin.es6